import {Theme} from '../theme';

import {useTheme as useThemeImpl} from '@emotion/react';

export default function useAppTheme(): Theme {
  return useThemeImpl() as Theme;
}